"use strict";
import { createContext, useContext, useMemo } from "react";
import { useFiatConverter } from "features/fiatCurrency/conversion";
import { useLocalizedFormatter } from "features/language/formatter";
export const LocalizationContext = createContext(void 0);
export function LocalizationContextProvider({ children }) {
  const { formatNumberOrString, formatCurrencyAmount, formatPercent, addFiatSymbolToNumber } = useLocalizedFormatter();
  const { convertFiatAmount, convertFiatAmountFormatted, conversionRate } = useFiatConverter({
    formatNumberOrString
  });
  const state = useMemo(
    () => ({
      conversionRate,
      convertFiatAmount,
      convertFiatAmountFormatted,
      formatNumberOrString,
      formatCurrencyAmount,
      formatPercent,
      addFiatSymbolToNumber
    }),
    [
      addFiatSymbolToNumber,
      conversionRate,
      convertFiatAmount,
      convertFiatAmountFormatted,
      formatCurrencyAmount,
      formatNumberOrString,
      formatPercent
    ]
  );
  return <LocalizationContext.Provider value={state}>{children}</LocalizationContext.Provider>;
}
export const useLocalizationContext = () => {
  const localizationContext = useContext(LocalizationContext);
  if (localizationContext === void 0) {
    throw new Error("`useLocalizationContext` must be used inside of `LocalizationContextProvider`");
  }
  return localizationContext;
};
